import React, { useMemo } from 'react'
import { BillingCard, HeaderLinks } from './components'
import { BillingModal } from './components/billing-modal'
import { Table, EmptyData } from '../../components'
import * as S from './styles'
import { LoadFromModal } from '../../../domain/models/billing-models'
import CardPayment from './components/card-payment'
import { useModalBox } from '../../contexts'

type Props = {
  consumition: any[]
  billingForms?: any[]
  billing?: any[]
  loadFromModal: (period: string) => Promise<LoadFromModal>
}
const Billing = ({
  consumition,
  billing = [],
  billingForms = [],
  loadFromModal
}: Props) => {
  const { modalBox } = useModalBox()

  const columnsConsumition = useMemo(
    () => [
      {
        Header: 'Data',
        accessor: 'dataConsumo',
        style: {
          width: '20%',
          minWidth: 120
        }
      },
      {
        Header: 'Nome',
        accessor: 'nomePaciente'
      },
      {
        Header: 'Demanda',
        accessor: 'demandaServico'
      }
    ],
    []
  )

  const columnsBilling = useMemo(
    () => [
      {
        Header: 'Descrição',
        accessor: 'descricao'
      },
      {
        Header: 'Data',
        accessor: 'createdAt'
      },
      {
        Header: 'Valor',
        accessor: 'valor'
      },
      {
        Header: 'Tipo de Pagamento',
        accessor: 'formaPagamento'
      },
      {
        Header: 'Status',
        accessor: 'status'
      }
    ],
    []
  )

  return (
    <S.Wrapper>
      <S.Title>Meu faturamento</S.Title>
      <S.CardContainer>
        <HeaderLinks
          routes={['/meus-dados', '/alterar-senha', '/meu-faturamento']}
        />
        <BillingCard
          title="Meu consumo"
          body={
            <div>
              {(!consumition || !consumition.length) && (
                <EmptyData>Ainda não há Consumo</EmptyData>
              )}
              {consumition && consumition?.length > 0 && (
                <>
                  <Table
                    columns={columnsConsumition}
                    dataTable={consumition}
                    hasPagination={false}
                  />
                  <span
                    className="modal-click"
                    onClick={() => {
                      return modalBox(
                        <BillingModal
                          header="Consumo"
                          loadFromModal={loadFromModal}
                        />,
                        'Histórico de Consumo',
                        '65%',
                        '85%'
                      )
                    }}
                  >
                    Ver meu historico de consumo
                  </span>
                </>
              )}
            </div>
          }
        />
        <BillingCard
          title="Formas de pagamento"
          body={
            <div>
              {!billingForms.length && (
                <EmptyData>Ainda não há Formas de pagamento</EmptyData>
              )}

              {billingForms && billingForms.length > 0 && (
                <CardPayment data={billingForms} />
              )}
            </div>
          }
        />
        <BillingCard
          title="Faturamento"
          body={
            <div>
              {!billing.length && (
                <EmptyData>Ainda não há Faturamentos</EmptyData>
              )}

              {billing && billing.length > 0 && (
                <>
                  <Table
                    columns={columnsBilling}
                    dataTable={billing}
                    hasPagination={false}
                  />

                  <span
                    className="modal-click"
                    onClick={() => {
                      return modalBox(
                        <BillingModal header="Pagamentos" />,
                        'Histórico de Pagamentos',
                        '65%',
                        '80%'
                      )
                    }}
                  >
                    Ver meu historico de pagamentos
                  </span>
                </>
              )}
            </div>
          }
        />
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Billing
